module.exports = __webpack_public_path__ + "static/hostel-ljubas-logo_transparent-40cf81036f4d1b88cb043c8cc66b9821.svg";